import { createSelector } from '@reduxjs/toolkit';
import { getUseSpotlightLauncher } from '../../widget-data/selectors/widgetDataSelectors';
import { getIsAIChatbot } from '../../selectors/widgetDataSelectors/getIsAIChatbot';
import { getShowGdprConsentToProcess } from '../../gdpr/selectors/getShowGdprConsentToProcess';
import { shouldRequireExplicitCookieConsent } from '../../selectors/widgetDataSelectors/shouldRequireExplicitCookieConsent';
import { getIsExitIntentCookiePrompt } from '../../utils/gdprCookieConsentPromptHelpers';
export const getShouldHideForConsent = createSelector([getShowGdprConsentToProcess, shouldRequireExplicitCookieConsent, getIsAIChatbot, getIsExitIntentCookiePrompt], (requiresExplicitConsentToProcess, renderCookieConsentPrompt, isAIChatbot, isExitIntentCookiePrompt) => {
  const hasConsentRequirement = requiresExplicitConsentToProcess || renderCookieConsentPrompt;
  if (!hasConsentRequirement) {
    return false;
  }
  if (!isAIChatbot) {
    return true;
  }
  return renderCookieConsentPrompt && isExitIntentCookiePrompt;
});
export const getShouldHideMessageEditor = createSelector([getUseSpotlightLauncher, getShouldHideForConsent], (useSpotlightLauncher, hideForConsent) => useSpotlightLauncher || hideForConsent);